/** Bound server work while keeping the stream open long enough to settle refunds. */
export const LISTING_INTER_DESIGN_DELAY_MS = 1000;
export function listingBatchTimeBudget(designCount: number): { workMs: number; transportMs: number } {
	const count = Number.isFinite(designCount) ? Math.max(1, Math.floor(designCount)) : 1;
	const workMs = Math.min(60 * 60_000, Math.max(10 * 60_000, count * 2 * 60_000));
	return { workMs, transportMs: workMs + 60_000 };
}
